import { memo } from 'react'
import { styled } from '@mui/material'
import { MagnifyingGlass } from '@phosphor-icons/react'
import { rem } from 'polished'

export interface GlobalSearchFieldAnchorProps {
  placeholder: string
  onClick: () => void
}

const GlobalSearchFieldAnchorWrapper = styled('button')(({ theme }) => ({
  width: rem('170px'),
  height: rem('28px'),
  background: theme.colours.baseExtraLight,
  borderRadius: theme.display.borderRadius,
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  borderStyle: 'solid',
  borderColor: theme.colours.foreground,
  borderWidth: theme.display.inputBorderWidth,
  '&:hover': {
    borderColor: theme.colours.baseLight,
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.colours.baseMid,
  fontSize: theme.typography.pxToRem(14),
}))

const KeyboardHint = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(11),
  color: theme.colours.baseMid,
  background: theme.colours.foreground,
  borderRadius: theme.display.borderRadius,
  padding: `1px ${theme.spacing(0.5)}`,
  lineHeight: 1,
  whiteSpace: 'nowrap',
}))

const LeftContent = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

const IS_MAC = (() => {
  const platform =
    (navigator as Navigator & { userAgentData?: { platform: string } }).userAgentData?.platform ?? navigator.platform
  return platform.toLowerCase().includes('mac')
})()

const _GlobalSearchFieldAnchor = ({ placeholder, onClick }: GlobalSearchFieldAnchorProps): JSX.Element => (
  <GlobalSearchFieldAnchorWrapper onClick={onClick} aria-keyshortcuts="Meta+k Control+k">
    <LeftContent>
      <MagnifyingGlass size={16} weight="bold" />
      {placeholder}
    </LeftContent>
    <KeyboardHint>{IS_MAC ? '⌘K' : 'Ctrl+K'}</KeyboardHint>
  </GlobalSearchFieldAnchorWrapper>
)

const GlobalSearchFieldAnchor = memo(_GlobalSearchFieldAnchor)

export default GlobalSearchFieldAnchor
